/**
 * @generated SignedSource<<2dcbf89f7c1ebaced8831c6637c6eaa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCompanySupportWhatsApp_company$data = {
  readonly preferences: {
    readonly support: {
      readonly phone: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentCompanySupportWhatsApp_company";
};
export type PaymentCompanySupportWhatsApp_company$key = {
  readonly " $data"?: PaymentCompanySupportWhatsApp_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanySupportWhatsApp_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCompanySupportWhatsApp_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferencesSupport",
          "kind": "LinkedField",
          "name": "support",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phone",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "3980dab14b7bb8f73a568717aa1dad9f";

export default node;
